import { reducer } from './reducer';
import { sagas } from './sagas';


export * from './actions';
export * from './utils';

export const info = {
    reducer,
    sagas,
};
